import React, { useEffect, useState } from "react";
import { api, euro } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

let cache = null;
const loadCosts = () => {
  if (!cache) cache = api.get("/admin/source-costs").then((r) => r.data).catch(() => { cache = null; return null; });
  return cache;
};
export const resetSourceCosts = () => { cache = null; };

export const useSourceCosts = () => {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [costs, setCosts] = useState(null);
  useEffect(() => {
    if (!isAdmin) { return; }
    let active = true;
    loadCosts().then((data) => { if (active) setCosts(data); });
    return () => { active = false; };
  }, [isAdmin]);
  return { isAdmin, costs };
};

export const pctCost = (costs, key, amount) => {
  const pct = costs?.pct?.[key];
  return pct == null || amount == null ? null : Math.round(Number(amount) * pct) / 100;
};

export const AdminCost = ({ cost, estimated, note, testId = "admin-source-cost", className = "" }) => {
  const { user } = useAuth();
  if (user?.role !== "admin") return null;
  return (
    <span className={`inline-flex items-center gap-1 rounded-md border border-amber-500/40 bg-amber-500/10 px-1.5 py-0.5 text-[11px] font-medium text-amber-600 dark:text-amber-400 whitespace-nowrap ${className}`} data-testid={testId}>
      Costo alla fonte {cost == null ? "non impostato" : euro(cost)}{cost != null && estimated ? " · stimato" : ""}{note ? ` · ${note}` : ""}
    </span>
  );
};
